<template>
  <!-- 审批弹窗 -->
  <el-dialog
    :close-on-click-modal="false"
    title="审批"
    :visible.sync="dialogVisible"
    class="mini-dialog"
    v-dialogDrag
    append-to-body
    @close="cancel"
  >
    <el-form ref="form" label-width="150px" :model="form">
      <el-form-item
        label="审批结果"
        prop="isPass"
        :rules="[{ required: true, message: '请选择审批结果', trigger: 'blur' }]"
      >
        <el-radio-group v-model="form.isPass">
          <el-radio :label="true">审批通过</el-radio>
          <el-radio :label="false">不通过</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="审批意见"
        prop="opinion"
        :rules="[{ required: true, message: '请输入审批意见', trigger: 'blur' }]"
      >
        <el-input v-model="form.opinion" type="textarea" :rows="4" maxlength="500" show-word-limit>
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="flex justify-center">
      <el-button size="small" type="primary" @click="save" :loading="loading">保存</el-button>
      <el-button size="small" @click="cancel">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        isPass: true,
        opinion: '',
      },
    }
  },
  computed: {
    dialogVisible: {
      get() {
        console.log('get dialogVisible', this.visible)
        return this.visible
      },
      set(val) {
        console.log('set dialogVisible', val)
        this.$emit('update:visible', val)
      },
    },
  },
  methods: {
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('submit', this.form)
        }
      })
    },
    cancel() {
      this.form = this.$options.data().form
      this.dialogVisible = false
    },
  },
}
</script>
